"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemTextSuffix = exports.ListItemSideElement = exports.ListItemInnerContainer = exports.ListItemHoverAction = exports.ListItemContentWrapper = exports.ListItemContent = exports.ListItemContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _HBListItem = require("./HBListItem.constants");
var ListItemInnerContainer = exports.ListItemInnerContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBListItemstyles__ListItemInnerContainer",
  componentId: "sc-mgic1r-0"
})(["width:100%;max-width:100%;display:flex;align-items:center;gap:8px;padding:", "px ", "px;min-height:", "px;border-radius:", ";background-color:", ";", ""], function (_ref) {
  var size = _ref.size;
  return _HBListItem.SIZE_TO_PADDING[size];
}, _HBListItem.INNER_CONTAINER_PADDING_X, function (_ref2) {
  var size = _ref2.size,
    withSubtext = _ref2.withSubtext;
  return _HBListItem.SIZE_TO_HEIGHT[size][withSubtext ? 'enlargedSize' : 'defaultSize'];
}, function (_ref3) {
  var rounded = _ref3.rounded;
  return rounded ? '4px' : 0;
}, function (_ref4) {
  var theme = _ref4.theme,
    selected = _ref4.selected;
  return selected ? _HBListItem.THEME[theme].accentColor : 'transparent';
}, _mixins.focusOutlineState);
var ListItemContainer = exports.ListItemContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBListItemstyles__ListItemContainer",
  componentId: "sc-mgic1r-1"
})(["position:relative;display:flex;width:100%;max-width:100%;align-items:center;min-width:150px;padding:", "px ", "px;opacity:", ";color:", ";cursor:", ";&[data-interactive]{cursor:", ";}& > *{background-color:", ";}&[data-interactive]:hover > ", ",&[data-interactive][data-hover] > ", ",&[data-interactive][data-highlighted] > ", ",&[data-interactive][data-state='open'] > ", ",&[data-interactive] > ", "[data-focus-visible]{background-color:", ";}"], _HBListItem.CONTAINER_PADDING_Y, _HBListItem.CONTAINER_PADDING_X, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 0.5 : 1;
}, function (_ref6) {
  var theme = _ref6.theme;
  return _colors["default"][_HBListItem.THEME[theme].color];
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? 'not-allowed' : 'default';
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref9) {
  var theme = _ref9.theme,
    selected = _ref9.selected;
  return selected ? _HBListItem.THEME[theme].accentColor : 'transparent';
}, ListItemInnerContainer, ListItemInnerContainer, ListItemInnerContainer, ListItemInnerContainer, ListItemInnerContainer, function (_ref0) {
  var theme = _ref0.theme,
    selected = _ref0.selected;
  return _HBListItem.THEME[theme][selected ? 'accentColor' : 'hoverColor'];
});
var ListItemSideElement = exports.ListItemSideElement = _styledComponents["default"].div.withConfig({
  displayName: "HBListItemstyles__ListItemSideElement",
  componentId: "sc-mgic1r-2"
})(["display:flex;align-items:center;position:relative;color:inherit;flex-shrink:0;> i{display:flex;svg *{fill:currentColor;}}"]);
var ListItemTextSuffix = exports.ListItemTextSuffix = _styledComponents["default"].div.withConfig({
  displayName: "HBListItemstyles__ListItemTextSuffix",
  componentId: "sc-mgic1r-3"
})(["align-self:flex-start;"]);
var ListItemHoverAction = exports.ListItemHoverAction = _styledComponents["default"].div.withConfig({
  displayName: "HBListItemstyles__ListItemHoverAction",
  componentId: "sc-mgic1r-4"
})(["flex-shrink:0;visibility:hidden;", ":is(:hover,:focus-visible,:focus-within):not([data-disabled]) &{visibility:visible;}"], ListItemContainer);
var ListItemContentWrapper = exports.ListItemContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBListItemstyles__ListItemContentWrapper",
  componentId: "sc-mgic1r-5"
})(["display:flex;align-items:center;justify-content:flex-start;gap:4px;flex:1;"]);
var ListItemContent = exports.ListItemContent = _styledComponents["default"].div.withConfig({
  displayName: "HBListItemstyles__ListItemContent",
  componentId: "sc-mgic1r-6"
})(["display:flex;flex-direction:column;"]);
//# sourceMappingURL=HBListItem.styles.js.map